import React, {useState} from "react";
import {connect} from 'react-redux'
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import AgreementsListType from "./components/AgreementsListType";
import AgreementListType from "./constants/AgreementListType";
import AgreementsAvailablePanel from "./components/AgreementsAvailablePanel";
import AgreementsCreatedPanel from "./components/AgreementsCreatedPanel";

function AgreementsPanel(
    {
        match,
        demandValidation
    }) {

    const curDemandValidation = DemandValidation.AGREEMENTS;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;
    const [listType, setListType] = useState(AgreementListType.AVAILABLE);

    return (<div>
        <AgreementsListType
            listType={listType}
            setListType={setListType}
        />
        {listType === AgreementListType.AVAILABLE && <AgreementsAvailablePanel editable={editable} demandId={demandId}/>}
        {listType === AgreementListType.CREATED && <AgreementsCreatedPanel editable={editable} demandId={demandId}/>}
    </div>)
}


export default connect((state) => ({
    demandValidation: state.resources.demandValidation
}), {})(withRouter(AgreementsPanel));